import { PRODUCTION_TRANSACTION_AVAILABLE_REQUEST, GET_PRODUCTION_TRANSACTIONS_AVAILABLE_TAKA_NO, PRODUCTION_TRANSACTION_AVAILABLE_REQUEST_FAILURE,
  GET_PRODUCTION_AVAILABLE_TRANSACTIONS } from '../types';

const initialState = {
  availableTransactions: [],
  availableTakaNos: [],
  loading: false,
  error: null,
};

const productionAvailableTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCTION_TRANSACTION_AVAILABLE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_PRODUCTION_AVAILABLE_TRANSACTIONS: {
      return {
        ...state,
        availableTransactions: [ ...action.payload ],
        loading: false,
        error: null
      }
    }
    case GET_PRODUCTION_TRANSACTIONS_AVAILABLE_TAKA_NO: {
      return {
        ...state,
        availableTakaNos: [ ...action.payload ],
        loading: false,
        error: null
      }
    }
    case PRODUCTION_TRANSACTION_AVAILABLE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default productionAvailableTransactionReducer;
